/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfileDetailsDelete: "good-profile-details-delete",
  goodProfileDetailsEdit: "good-profile-details-edit",
  goodProfileDetailsOpen: "good-profile-details-open",
} as const;
